import { Component, DestroyRef, OnInit, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';
import { MenuService } from '../../../services/menu/menu.service';
import { StickyState } from '../../../domain/menu.domain';

@Component({
  selector: 'td-wb-toolbar',
  templateUrl: 'toolbar.component.html',
  styleUrls: ['toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  private readonly mediaQueryService = inject(MediaQueryService);
  private readonly menuService = inject(MenuService);
  private readonly destroyRef = inject(DestroyRef);

  readonly modal = input(false);

  readonly menuSticky = signal(false);
  readonly display = signal(false);

  ngOnInit(): void {
    this.mediaQueryService.observe(Breakpoint.SM, Breakpoint.MD)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((state: BreakpointState): void => this.onScreenChange(state.matches));
    this.menuService.onStickyStateChangeSubject
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((menuState: StickyState): void => this.onMenuStateChange(menuState));
  }

  private onMenuStateChange(menuState: StickyState): void {
    if (this.modal()) {
      this.menuSticky.set(false);
      return;
    }
    this.menuSticky.set(menuState === StickyState.STICKY);
  }

  private onScreenChange(isSmallScreen: boolean): void {
    const display = this.setDisplay(isSmallScreen);
    if (display !== this.display()) {
      this.display.set(display);
    }
  }

  private setDisplay(isSmallScreen: boolean): boolean {
    return !isSmallScreen;
  }
}
